// @core/api/endpoints/project/list_sprints.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSprintsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List sprints
 * Returns all sprints for the project with optional status filtering. Includes active, planned, and completed sprints.
 */
export async function ListSprints(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSprintsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListSprintsResponse>(requestPath, { ...requestOptions, params });
}
